// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAnalytics from 'vue-analytics'
import fuckadblock from 'fuckadblock' // eslint-disable-line
import * as moment from 'moment'
import Ads from 'vue-google-adsense'

Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
	id: 'UA-109050712-1',
	checkDuplicatedScript: true,
	router,
	autoTracking: {
		pageviewTemplate (route) {
			return {
				page: route.path,
				title: document.title,
				location: window.location.href
			}
		}
	}
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	template: '<App/>',
	components: { App },
	mounted () {
		const self = this
		if (typeof window.fuckAdBlock !== 'undefined') {
			window.fuckAdBlock.onDetected(() => {
				if (typeof localStorage !== 'undefined') {
					let timestamp = localStorage.getItem('adblock')
					timestamp = parseInt(timestamp === null ? 0 : timestamp)
					if (timestamp <= moment().unix()) {
						document.querySelector('html').classList.add('lightbox--active', 'lightbox--active-adblock')
					}
				}
				self.$ga.event('adBlock', 'detect')
			})
			window.fuckAdBlock.onNotDetected(() => {
				self.$ga.event('adBlock', 'nodetect')
			})
			window.fuckAdBlock.check()
		} else {
			self.$ga.event('adBlock', 'nodetect')
		}
	}
})



// WEBPACK FOOTER //
// ./src/main.js